/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import FontAwesome from 'react-fontawesome';
import PropTypes from '../util/prop_types';
import { MapActionCreators } from '../stores/map_action_creators';

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = {
  addAction: MapActionCreators.addAction,
};

class MenuChecklistItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: props.item.get('isChecked', false),
    }
  }

  static propTypes = {
    addAction: PropTypes.func.isRequired,
    item: PropTypes.immutable.map.isRequired,
  }

  _onChange = (e) => {
    const isChecked = e.target.checked;
    this.setState({isChecked});

    //addAction
    this.props.item.get('layers', Immutable.List()).forEach(layer => {
      this.props.addAction("setLayoutProperty", {
        layer,
        name: 'visibility',
        value: isChecked ? 'visible': 'none'
      });
    });
  }

  render(): ?React.Element<any> {
    const { item } = this.props;

    let label = item.get('label');
    let icon = item.get('icon');

    return (
      <li>
        <label>
          <input
            type="checkbox"
            checked={this.state.isChecked}
            onChange={this._onChange} />
          {icon &&
            <img src={icon} />
          }
          {label}
        </label>
      </li>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuChecklistItem);
